import TrackPlayer from 'react-native-track-player';
import { PlaybackEventEmitter, PlaybackEvent } from '@annunciate/core';
import { getStreamFromContent } from '@annunciate/download';
import { getContentProgress } from '@annunciate/query';
import { contentToAudioTrack } from '../player';
import { getPositionTime, getProgressTime, } from '@annunciate/ui/dist/utils/progress';
export const onPlayNewAudio = async ({ client, content, initialPosition, playOnLoad = true, }) => {
    const progress = getContentProgress(client, content.id);
    const streamable = await getStreamFromContent(content, client);
    if (!streamable.content || !streamable.stream) {
        PlaybackEventEmitter.emit(PlaybackEvent.UNKOWN_ERROR, {
            content,
            message: 'An error occurred when attempting to fetch a valid stream. Please try again or contact support.',
        });
        return;
    }
    const track = contentToAudioTrack(streamable.content, streamable.stream);
    let initialTime = 0;
    if (initialPosition) {
        initialTime = getPositionTime(initialPosition);
    }
    else if (progress && progress.percentage !== 100) {
        initialTime = getProgressTime(progress);
    }
    await TrackPlayer.setPlayWhenReady(false);
    await TrackPlayer.add(track);
    const queue = await TrackPlayer.getQueue();
    if (queue.length > 1) {
        await TrackPlayer.skip(queue.length - 1, initialTime);
    }
    await TrackPlayer.seekTo(initialTime);
    if (!playOnLoad) {
        await TrackPlayer.pause();
    }
    else {
        await TrackPlayer.play();
    }
    return streamable.content;
};
//# sourceMappingURL=onPlayNewAudio.js.map